import { IS_DEV } from '../constants';

export const devLog = IS_DEV ? console.log : () => {};
export const devError = IS_DEV ? console.error : () => {};
export const devWarn = IS_DEV ? console.warn : () => {};
export const devClear = IS_DEV ? console.clear : () => {};
